export const SOUTH_AFRICA_VIEW = {
  latitude: -29,
  longitude: 24,
  zoom: 4,
} as const;

export const SOUTH_AFRICA_BOUNDS: [[number, number], [number, number]] = [
  [16.34, -34.84],
  [32.84, -22.12],
];

export function mapStartForCoordinates(
  coordinates: [number, number] | null,
  fallbackCenter: [number, number] | null = null
) {
  const center = coordinates ?? fallbackCenter;
  if (!center) {
    return SOUTH_AFRICA_VIEW;
  }

  return {
    longitude: center[0],
    latitude: center[1],
    zoom: 16,
  };
}
